import * as React from 'react'

export const CommunityIcon = React.memo<JSX.IntrinsicElements['svg']>(
  (props) => {
    return (
      <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M26.8263 7.42429C25.7669 9.91579 22.2337 9.91572 21.174 7.42493C21.1293 7.32001 20.9638 6.97819 20.5845 6.66988C20.2535 6.4009 19.5735 6 18.1982 6C16.8592 6 15.9462 6.64337 15.4379 7.65316C14.8973 8.72721 14.7352 10.4412 15.63 12.4484C16.4616 14.3144 18.1876 16.289 20.1287 17.8275C21.0779 18.5798 22.0004 19.1651 22.7752 19.5478C23.5351 19.9231 23.9302 19.9932 23.9924 20.0043L24.0002 20.0057L24.0071 20.0045C24.067 19.9941 24.4641 19.9251 25.23 19.548C26.0058 19.166 26.9292 18.5819 27.8783 17.8309C29.8199 16.2947 31.5416 14.3236 32.3659 12.4577L32.37 12.4484C33.2648 10.4412 33.1027 8.72721 32.5621 7.65316C32.0538 6.64337 31.1408 6 29.8018 6C28.4256 6 27.7456 6.40105 27.4151 6.66973C27.0362 6.97772 26.8709 7.31921 26.8263 7.42429Z"
          fill="#0070E0"
        />
        <path
          d="M14.9418 19.9377C14.9418 21.3636 14.184 22.6125 13.049 23.3035C15.9173 24.1784 18.0039 26.8455 18.0039 30V30.7143C18.0039 31.4243 17.4283 32 16.7182 32H5.28962C4.57954 32 4.00391 31.4243 4.00391 30.7143V30C4.00391 26.8454 6.09064 24.1782 8.95905 23.3034C7.82422 22.6124 7.06641 21.3635 7.06641 19.9377C7.06641 17.763 8.82938 16 11.0041 16C13.1789 16 14.9418 17.763 14.9418 19.9377Z"
          fill="#0070E0"
        />
        <path
          d="M40.9418 19.9377C40.9418 21.3636 40.184 22.6125 39.049 23.3035C41.9173 24.1784 44.0039 26.8455 44.0039 30V30.7143C44.0039 31.4243 43.4283 32 42.7182 32H31.2896C30.5795 32 30.0039 31.4243 30.0039 30.7143V30C30.0039 26.8454 32.0906 24.1782 34.9591 23.3034C33.8242 22.6124 33.0664 21.3635 33.0664 19.9377C33.0664 17.763 34.8294 16 37.0041 16C39.1789 16 40.9418 17.763 40.9418 19.9377Z"
          fill="#0070E0"
        />
        <path
          d="M26.049 31.3035C27.184 30.6125 27.9418 29.3636 27.9418 27.9377C27.9418 25.763 26.1789 24 24.0041 24C21.8294 24 20.0664 25.763 20.0664 27.9377C20.0664 29.3635 20.8242 30.6124 21.9591 31.3034C19.0906 32.1782 17.0039 34.8454 17.0039 38V38.7143C17.0039 39.4243 17.5795 40 18.2896 40H29.7182C30.4283 40 31.0039 39.4243 31.0039 38.7143V38C31.0039 34.8455 28.9173 32.1784 26.049 31.3035Z"
          fill="#0070E0"
        />
      </svg>
    )
  },
)

CommunityIcon.displayName = 'CommunityIcon'
